import React from "react";
import { Chip, SxProps, ChipProps } from "@mui/material";
import { AccountColour } from "__generated__/graphql";
import { getAccountColour } from "switchAccount/helpers/getAccountColour";

interface IOptionChipProps extends ChipProps {
  option: {
    colour: AccountColour;
    value: string;
  };
  onDelete?: (event: any) => void;
  onClick?: () => void;
  sx?: SxProps;
}
export const OptionChip: React.FC<IOptionChipProps> = ({
  option,
  onClick,
  onDelete,
  sx,
  ...other
}) => {
  return (
    <Chip
      sx={{
        backgroundColor: getAccountColour(option.colour),
        ...sx,
      }}
      label={option.value}
      onClick={onClick}
      onDelete={onDelete}
      {...other}
    />
  );
};
